import {ChangeDetectorRef, Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  ParentRegistryContexts,
  RegistryContexts,
  TipoEsami,
} from "@app/models/constants/registry-constants";
import {PdtaService} from "@app/services/pdta.service";
import {CommonState} from "@app/store/common/common.state";
import {TpAdvActions} from "@doctor-panel-modules/patient-treatment-plan/store/patient-treatment-plan-adv.actions";
import {PatientTreatmentPlanAdvState} from "@doctor-panel-modules/patient-treatment-plan/store/patient-treatment-plan-adv.state";
import {ModalController} from "@ionic/angular";
import {DialogAddPatientComponent} from "@modules/doctor-panel/components/dialog-add-patient/dialog-add-patient.component";
import {DoctorPanelActions} from "@modules/doctor-panel/store/doctor-panel.actions";
import {hasActionsExecuting} from "@ngxs-labs/actions-executing";
import {Select, Store} from "@ngxs/store";
import {TrecError} from "@trec/api";
import {PdaEntry} from "@trec/api/salute-helper";
import {C3SnackbarStatusService} from "@trec/components/snackbar-status";
import {Observable, Subscription} from "rxjs";
import {DialogPrescriptionPdtaComponent} from "./dialog-prescription-pdta/dialog-prescription-pdta.component";

@Component({
  selector: "app-config-pdta",
  templateUrl: "./config-pdta.component.html",
  styleUrls: ["./config-pdta.component.scss"],
  standalone: false
})
export class ConfigPdtaComponent implements OnInit, OnDestroy {
  @Select(PatientTreatmentPlanAdvState.availableEsamiPdta)
  availableEsamiPdta$: Observable<any | undefined>;
  @Select(
    hasActionsExecuting([TpAdvActions.FetchEsamiPdtaList, DoctorPanelActions.PrescriptionUrlPdta])
  )
  loading$: Observable<boolean>;

  private readonly subscr = new Subscription();
  readonly CTXS_PARENT = ParentRegistryContexts;
  readonly TipoEsami = TipoEsami;

  availableEsamiPdta: any;
  esamiRicercati: any[];
  prescriptionUrlPdta: any[];

  @Input()
  context: RegistryContexts[];

  descrizioneEsameRicercato: any;
  esameRicercato: any;
  esamiList: any[];
  resultsAvailable?: boolean;
  esameSelected?: boolean;
  loadingRicerca: boolean;
  trimestreCorrente: string;
  parentContext: string | null;
  currentTrimestre?: string;

  constructor(
    private store: Store,
    protected cd: ChangeDetectorRef,
    private modalCtrl: ModalController,
    private c3Snackbar: C3SnackbarStatusService,
    private pdtaService: PdtaService
  ) { }

  ngOnInit(): void {
    this.getEsamiPdtaList();

    this.subscr.add(
      this.availableEsamiPdta$.subscribe((esamiPdta) => {
        if (esamiPdta) {
          this.availableEsamiPdta = {...esamiPdta};
          let pdtaEntry = this.setCheckedPdtaEntry(esamiPdta.pdtaEntry, true);

          this.availableEsamiPdta.pdtaEntry = pdtaEntry;
          this.trimestreCorrente =
            esamiPdta.currentTrimester != null ? esamiPdta.currentTrimester.toString() : "1";
        }
      })
    );
  }

  /**
   * recupera la lista degli esami
   */
  getEsamiPdtaList() {
    const patientId = this.store.selectSnapshot(CommonState.patientId);
    this.parentContext = localStorage.getItem("c3-curr-context");
    const currentPersonalData = this.store.selectSnapshot(CommonState.patientPersonalData) || {};
    console.log(currentPersonalData);

    if (patientId && this.parentContext) {
      this.store.dispatch(
        new TpAdvActions.FetchEsamiPdtaList({trecUserId: patientId, context: this.parentContext})
      );
    }
  }

  /**
   * imposta parametro checked nel pdtaEntry
   * @param pdtaEntry
   * @param checked
   * @returns
   */
  setCheckedPdtaEntry(pdtaEntry, isChecked) {
    var pdtaEntryObj: any = {};
    Object.keys(pdtaEntry).forEach((keys) => {
      pdtaEntryObj[keys] = pdtaEntry[keys].map((obj) =>
        Object.assign({}, obj, {checked: isChecked})
      );
    });
    return pdtaEntryObj;
  }

  async sostitusciPdta() {
    const modal = await this.modalCtrl.create({
      component: DialogAddPatientComponent,
      cssClass: "c3-modal-width-sm c3-modal-height-lg",
      componentProps: {
        isArruolamento: false,
        trecUserId: this.store.selectSnapshot(CommonState.patientId) ?? "",
      },
    });
    modal.onDidDismiss().then((data) => {
      this.refreshPdtaList();
    });

    return await modal.present();
  }

  refreshPdtaList() {
    const patientId = this.store.selectSnapshot(CommonState.patientId);

    if (patientId && this.parentContext) {
      this.store.dispatch(
        new TpAdvActions.FetchEsamiPdtaList({trecUserId: patientId, context: this.parentContext})
      );
    }
  }

  trimestreSelectionChange(event, esame) {
    esame.opzionale = false;
    esame.trimestre = [event.detail.value];
  }

  /**
   * aggiunta delle esame selezionato
   */
  aggiungiEsame(esame) {
    if (!esame.trimestre) {
      this.c3Snackbar.showError({
        error: new TrecError("invalid_data", "Indicare il trimestre"),
        messagesMap: {
          invalid_data: "E' necessario indicare il trimestre",
        },
      });
      return;
    }

    this.availableEsamiPdta.pdtaEntry["O"] = this.availableEsamiPdta.pdtaEntry["O"].filter(
      function (e) {
        return e !== esame;
      }
    );

    this.availableEsamiPdta.pdtaEntry[esame.trimestre[0]].push(esame);
  }

  /**
   * salvataggio esami
   * @returns
   */
  prepareSaveDataAction() {
    let pdaEntryList = this.componiPdaEntryList();

    if (this.parentContext) {
      this.store
        .dispatch(
          new DoctorPanelActions.SalvaPdta({
            trecUserId: this.store.selectSnapshot(CommonState.patientId) ?? "",
            pdaEntry: pdaEntryList,
            context: this.parentContext,
          })
        )
        .subscribe((data) => {
          if (this.parentContext != null) {
            this.c3Snackbar.showSuccess({message: `Pda salvato con successo`});
            this.getEsamiPdtaList();
          }
        });
      return null;
    }
    return null;
  }

  checkEsamiSenzaTrimestre(pdaEntryList) {
    //tolgo gli esami che non hanno il trimestre
    let esamiSenzaTrimestre = pdaEntryList.filter((x) => !x.trimestre);

    if (esamiSenzaTrimestre.length > 0) {
      this.c3Snackbar.showError({
        error: new TrecError("invalid_data", "Indicare il trimestre"),
        messagesMap: {
          invalid_data: "Indicare il trimestre negli esami opzionali.",
        },
      });
      return true;
    }
    return false;
  }

  componiPdaEntryList() {
    let checkedEsami = this.pdtaService.pulisciTrimestri(this.availableEsamiPdta.pdtaEntry);

    let pdaEntryList: any = [];
    checkedEsami.forEach((e) => {
      var entry: PdaEntry = {
        codiceRegionale: e.codiceRegionale ?? e.codice,
        codiceWebsanity: e.codiceWebsanity,
        descrizione: e.descrizione,
        nome: e.nome ?? e.descrizioneIntegrata,
        note: e.note,
        tempo: e.tempo,
        trimestre: e.trimestre,
        eseguito: e.eseguito,
        prenotato: e.prenotato,
        prescritto: e.prescritto,
        opzionale: e.opzionale,
      };

      //controllo che non sia presente nella lista
      if (!pdaEntryList.find((x) => x.codiceRegionale === entry.codiceRegionale)) {
        pdaEntryList.push(entry);
      }
    });
    return pdaEntryList;
  }

  prescriviEsami() {
    if (this.parentContext) {
      let pdaEntryList = this.componiPdaEntryList();

      let esamiSenzaTrimestre = this.checkEsamiSenzaTrimestre(pdaEntryList);
      if (esamiSenzaTrimestre) {
        return;
      }

      if (this.parentContext) {
        this.store
          .dispatch(
            new DoctorPanelActions.SalvaPdta({
              trecUserId: this.store.selectSnapshot(CommonState.patientId) ?? "",
              pdaEntry: pdaEntryList,
              context: this.parentContext,
            })
          )
          .subscribe((data) => {
            if (this.parentContext != null) {
              this.getEsamiPdtaList();

              this.store
                .dispatch(
                  new DoctorPanelActions.PrescriptionUrlPdta({
                    trecUserId: this.store.selectSnapshot(CommonState.patientId) ?? "",
                    context: this.parentContext,
                  })
                )
                // temporaneo, bisogna tipizzare la chiamata di salute-helper
                .subscribe(async (data: any) => {
                  const modal = await this.modalCtrl.create({
                    component: DialogPrescriptionPdtaComponent,
                    cssClass: "c3-modal-width-sm c3-modal-height-lg",
                    componentProps: {
                      prescriptionUrl: data.doctorPanel.prescriptionUrlPdta,
                      trecUserId: this.store.selectSnapshot(CommonState.patientId) ?? "",
                      parentContext: this.parentContext,
                    },
                  });
                  modal.onDidDismiss().then((data) => {
                    this.refreshPdtaList();
                  });

                  return await modal.present();
                });
            }
          });
        return null;
      }
      return null;
    }
    return null;
  }

  onSelectAll() {
    let pdtaEntry = this.setCheckedPdtaEntry(this.availableEsamiPdta.pdtaEntry, true);
    this.availableEsamiPdta.pdtaEntry = pdtaEntry;
  }

  onDeselectAll() {
    let pdtaEntry = this.setCheckedPdtaEntry(this.availableEsamiPdta.pdtaEntry, false);
    this.availableEsamiPdta.pdtaEntry = pdtaEntry;
  }

  ngOnDestroy() {
    this.subscr?.unsubscribe();
  }
}
